import { CassetteIcon } from './CassetteIcon';

/**
 * author: GreenTurtwig
 * id EF35081A-EABF-4C6B-B858-7F2177B60F95
 * name cassette
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cassette.svg
 * tags
 * - Music 
 */
export const TapeIcon = CassetteIcon;
export default TapeIcon